import AppSearchPageMixin from "@/protected/mixins/AppSearchPageMixin";
import SearchParametersEditor from "./ProviderSearchParametersEditor";
import service from "./ProviderService";

export default {
  mixins: [AppSearchPageMixin],

  components: {
    SearchParametersEditor
  },

  props: {
    columns: {
      default() {
        return [
          {
            key: "companyName",
            label: this.$t("provider.fields.companyName"),
            styleClass: "col-6",
            sortBy: "companyName",
            onClick: ({ row }) => {
              this.$router.push({ name: "Provider", params: { id: row.id } });
            }
          },
          {
            key: "fiscalCode",
            label: this.$t("provider.fields.fiscalCode"),
            styleClass: "col-3",
            sortBy: "fiscalCode"
          },
          {
            key: "vatNumber",
            label: this.$t("provider.fields.vatNumber"),
            styleClass: "col-3",
            sortBy: "vatNumber"
          }
          /*
          {
            key: 'lastModified',
            label: this.$t('common.lastModified'),
            sortBy: 'lastModified'
          },
          {
            key: 'lastModifiedOffline',
            label: this.$t('common.lastModifiedOffline')
          }
          */
        ];
      }
    }
  },

  data() {
    return {
      sort: {
        sort: "companyName",
        order: "ASC"
      }
    };
  },

  methods: {
    getService() {
      return service;
    },

    onAdd() {
      this.$router.push({ name: "Provider", params: { id: "new" } });
    }
  }
};
